import React, { Component } from 'react'
import {
  Row,
  Col,
  Form,
  Button,
  Card
} from 'reactstrap'
import { connect } from 'react-redux'
import {getLoginUrl} from "../utils/cognito";


function mapStateToProps (state) {
  return { loggedIn: state.auth.loggedIn }
}

class Auth extends Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.handleSubmit = this.handleSubmit.bind(this)
    this.componentWillMount = this.componentWillMount.bind(this)
  }

  componentWillMount () {
    if (this.props.loggedIn) this.props.history.push('/')
  }

  handleSubmit (e) {
    e.preventDefault()
    window.location.replace(getLoginUrl())
  }

  render () {
    return (
      <Row>
        <Col className='mt-3'>
          <Card body>
            <Form style={{textAlign:"center"}} onSubmit={this.handleSubmit}>
              <Button type="submit" disabled={this.state.loading}>
                Login
              </Button>
            </Form>
          </Card>
        </Col>
        <Col />
        <Col />
      </Row>
    )
  }
}

export default connect(mapStateToProps, null)(Auth)
